<template>
  <tab-layout>
    <li v-for="t in visibleTabs" :key="t.key" slot="tabHeading" class="nav-item">
      <a
        :class="['nav-link', selectedTab === t.key ? 'active' : '']"
        href
        @click.prevent="selectTab(t.key)"
        :id="`${t.key}-tab`"
        data-toggle="tab"
        role="tab"
        :aria-controls="t.key"
        :aria-selected="selectedTab === t.key ? 'true' : 'false'">{{ t.label }}</a>
    </li>
    <component
      v-if="currentTab"
      :is="currentTab.component"
      slot="tabContent"
      class="tab-pane row mx-0 show active"
      :id="currentTab.key"
      role="tabpanel"
      :aria-labelledby="`${currentTab.key}-tab`" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import horseProfileMembers from '@/views/Horses/Tabs/Members'
import horseProfileDetails from './HorseProfileDetails'
import horseProfileScore from './HorseProfileScore'
import horseProfileBoyHistory from './HorseProfileBoyHistory'

export default {
  name: 'HorseProfile',
  props: ['details'],
  components: {
    'tab-layout': tabLayout
  },
  data() {
    return {
      selectedTab: this.$route.hash ? this.$route.hash.slice(1) : 'details',
      userRole: localStorage.role
    }
  },
  mounted() {
    if (this.$route.params && this.$route.params.score) { // Go to score tab if coming from another score tab
      this.selectTab('score')
    }
  },
  computed: {
    isPrivileged() {
      return this.userRole === 'Admin' || this.userRole === 'SuperAdmin'
    },
    isSecretaryOrAdmin() {
      return this.isPrivileged || this.userRole === 'Secretary' || this.userRole === 'SecretaryOnly'
    },
    // Single source of truth for every tab on this page — add/remove/reorder tabs here only.
    tabs() {
      return [
        { key: 'details', label: 'Details', component: horseProfileDetails, show: true },
        { key: 'score', label: 'Results', component: horseProfileScore, show: true },
        { key: 'members', label: 'Members', component: horseProfileMembers, show: this.isSecretaryOrAdmin },
        { key: 'boy-history', label: 'BOY History', component: horseProfileBoyHistory, show: this.isPrivileged }
      ]
    },
    visibleTabs() {
      return this.tabs.filter(t => t.show)
    },
    currentTab() {
      return this.visibleTabs.find(t => t.key === this.selectedTab) || this.visibleTabs[0] || null
    }
  },
  methods: {
    selectTab(key) {
      this.selectedTab = key
      if (this.$route.hash !== `#${key}`) {
        this.$router.replace({ hash: `#${key}` }).catch(() => {})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Profile/HorseProfile.vue